import { MarketType } from '../enums/market-type.enum'
import { TrendIntervalType } from '../enums/trend-interval-type.enum'

export interface IAverageTrendData {
  previousYearStartTotal?: number
  previousYearEndTotal?: number
  previousYearDifference?: number
  formattedPreviousYearStartTotal?: string
  formattedPreviousYearEndTotal?: string
  formattedPreviousYearDifference?: string
  startTotal: number
  endTotal: number
  difference: number
  formattedStartTotal: string
  formattedEndTotal: string
  formattedDifference: string
}

export interface IAverageTrendSummary {
  id: string
  displayText: string
  marketType: MarketType
  countryId: string
  trendIntervalType: TrendIntervalType
  sales: IAverageTrendData
  cars: IAverageTrendData
  averageTicket: IAverageTrendData
}

export interface IAverageTrendDataExtended extends IAverageTrendData {
  index?: number
  id: string
  displayText: string
  marketType: MarketType
  noData?: boolean
  countryId: string
}

export interface IAverageTrendSummaryExtended {
  sales: IAverageTrendDataExtended[]
  cars: IAverageTrendDataExtended[]
  averageTicket: IAverageTrendDataExtended[]
}

export interface ITrendIntervalLabels {
  interval: TrendIntervalType
  initialPeriod: string
  finalPeriod: string
}

export interface IAverageTrendResponse {
  averageTrendSummaries: IAverageTrendSummary[]
  trendIntervalLabels: ITrendIntervalLabels[]
  trendsCustomInterval: number
}

export interface IAverageTrendResponseExtended {
  fourWeeks: IAverageTrendSummaryExtended
  previousYearFourWeeks: IAverageTrendSummaryExtended
  eightWeeks: IAverageTrendSummaryExtended
  previousYearEightWeeks: IAverageTrendSummaryExtended
  customWeeks: IAverageTrendSummaryExtended
  previousYearCustomWeeks: IAverageTrendSummaryExtended
  trendsCustomInterval: number
}
